module.exports = __webpack_public_path__ + "static/media/hydroclima.d41d3523.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/it/hydroclima.png
// module id = 116
// module chunks = 0